<template>
  <div v-show="progress != 100" class="preload-content">
    <p>资源加载中</p>
    <p>进度 {{ progress }}%</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      egretHalf: 0,
      warmupHalf: 0
    }
  },
  computed: {
    progress: function () {
      return Math.min(100, this.egretHalf + this.warmupHalf)
    }
  },
  mounted() {
    this.prefetchEgretAssets()
    this.warmupResourceCache()
  },

  methods: {
    // 预加载 Egret 相关脚本资源（后台预热缓存，不阻塞启动）50%
    async prefetchEgretAssets() {
      try {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 3000)
        const res = await fetch('./manifest.json?v=' + Math.random(), { signal: controller.signal })
        clearTimeout(timeoutId)
        if (!res || !res.ok) return
        const manifest = await res.json()
        const list = [].concat(manifest.initial || [], manifest.game || [])
        if (!list.length) return
        const total = list.length
        let done = 0
        const bump = () => {
          done++
          this.egretHalf = Math.round((done / total) * 10)
        }
        // 改为强制读取响应体，确保真实下载完成后再计数
        const downloadScript = async url => {
          try {
            const r = await fetch(url, { cache: 'force-cache' })
            if (!r || !r.ok) return
            await r.arrayBuffer()
          } catch (_) {
            return
          } finally {
            bump()
          }
        }
        await Promise.all(list.map(downloadScript))
      } catch (_) {
        // 忽略整体错误
        return null
      }
    },
    // 后台预热 /resource/preload.json 列表（并发限流，不阻塞渲染）90%
    warmupResourceCache() {
      const fetchWithTimeout = (url, timeoutMs) => {
        const controller = new AbortController()
        const id = setTimeout(() => controller.abort(), timeoutMs)
        return fetch(url, { signal: controller.signal }).finally(() => clearTimeout(id))
      }
      const start = async () => {
        try {
          const resp = await fetchWithTimeout('/resource/preload.json?v=' + Math.random(), 4000)
          if (!resp || !resp.ok) return
          const list = await resp.json()
          if (!Array.isArray(list) || list.length === 0) return

          // 可选：浏览器 hint，保留少量即可
          const prefetchCount = Math.min(10, list.length)
          for (let i = 0; i < prefetchCount; i++) {
            const link = document.createElement('link')
            link.rel = 'prefetch'
            link.href = list[i]
            document.head.appendChild(link)
          }

          const total = list.length
          let done = 0
          const bump = () => {
            done++
            this.warmupHalf = Math.round((done / total) * 90)
          }
          // 基于类型的真实下载器：图片/音频确保加载完成
          const preloadImage = url =>
            new Promise(resolve => {
              try {
                const img = new Image()
                img.onload = () => resolve()
                img.onerror = () => resolve()
                if ('decode' in img) {
                  img.src = url
                  img
                    .decode()
                    .then(() => resolve())
                    .catch(() => resolve())
                } else {
                  img.src = url
                }
              } catch (_) {
                resolve()
              }
            })
          const concurrency = 6
          let index = 0
          const worker = async () => {
            while (index < list.length) {
              const i = index++
              const url = list[i]
              try {
                await preloadImage(url)
              } catch (_) {
                /* ignore */
              }
              bump()
            }
          }
          await Promise.all(Array.from({ length: Math.min(concurrency, list.length) }, worker))
        } catch (_) {
          return null
        }
      }
      if (document.readyState === 'complete') {
        start()
      } else {
        window.addEventListener('load', start)
      }
    }
  }
}
</script>
<style scoped>
.preload-content {
  position: relative;
  font-size: 12px;
  color: #aaa;
}
.preload-content p {
  margin: 0;
}
</style>
